export const templateTypes = {
  DEFAULT: 'default',
  SPLIT: 'split',
  THEATRE: 'theatre',
};

export default { templateTypes };
